import { render, staticRenderFns } from "./MenuToppingOption.vue?vue&type=template&id=63870510&lang=pug&"
import script from "./MenuToppingOption.vue?vue&type=script&lang=js&"
export * from "./MenuToppingOption.vue?vue&type=script&lang=js&"
import style0 from "./MenuToppingOption.vue?vue&type=style&index=0&id=63870510&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports